import Crud from '../views/Advances/Crud'
import Entity from '../views/Advances/Add'
import Edit from '../views/Advances/Edit'
import View from '../views/Advances/View'

let routes = {
    path: '/advances',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/advances/add',
            name: 'NewAdvance',
            component: Entity,
            meta: {
                pageTitle: 'Adiantamento',
                breadcrumb: [
                    {
                        text: 'Adiantamentos',
                        active: false,
                        to: '/advances',
                    },
                    {
                        text: 'Solicitar Adiantamento',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/advances/edit/:id',
            name: 'EditAdvance',
            component: Edit,
            meta: {
                pageTitle: 'Gerenciar Adiantamento',
                breadcrumb: [
                    {
                        text: 'Adiantamentos',
                        active: false,
                        to: '/advances',
                    },
                    {
                        text: 'Gerenciar Adiantamento',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/advances/view/:id',
            name: 'ViewAdvance',
            component: View,
            meta: {
                pageTitle: 'Adiantamento',
                breadcrumb: [
                    {
                        text: 'Adiantamentos',
                        active: false,
                        to: '/advances',
                    },
                    {
                        text: 'Visualizar Adiantamento',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/advances',
            name: 'list-advances',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Adiantamentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes